
import { defineComponent, ref } from 'vue';

export default defineComponent({
	props: {
		playerCount: { type: Number, required: true },
		scenarioText: { type: String, required: true }
	},
	emits: ['update:playerCount', 'update:scenarioText'],
	setup() {
		const isOpen = ref(false);
		return { isOpen };
	}
});
